import {useCallback, useState} from "react";

export type WithdrawFlowStep = 'method' | 'destination' | 'review' | 'otp';

type BackHandlers = {
  isAddingCard: boolean, isBusy: boolean, onCancelAddCard: () => void, onClose: () => void, onLeaveReview: () => void,
  onLeaveOtp: () => void
};

const stepNumber: Record<WithdrawFlowStep, number> = {method: 1, destination: 2, review: 3, otp: 4};

export const useWithdrawFlowNavigation = () => {
  const [step, setStep] = useState<WithdrawFlowStep>('method');

  const getTitle = useCallback((isAddingCard: boolean) => {
    if (step === 'method') return 'Payout Method';
    if (step === 'destination' && isAddingCard) return 'Add Payout Card';
    if (step === 'destination') return 'Send To';
    if (step === 'review') return 'Review Withdrawal';
    return "Verify It's You";
  }, [step]);

  const reset = useCallback(() => setStep('method'), []);
  const showMethod = useCallback(() => setStep('method'), []);
  const showDestination = useCallback(() => setStep('destination'), []);
  const showReview = useCallback(() => setStep('review'), []);
  const showOtp = useCallback(() => setStep('otp'), []);

  const goBack = useCallback((handlers: BackHandlers) => {
    if (handlers.isBusy) return;
    if (handlers.isAddingCard) {
      handlers.onCancelAddCard();
      return;
    }
    if (step === 'otp') {
      handlers.onLeaveOtp();
      setStep('review');
      return;
    }
    if (step === 'review') {
      handlers.onLeaveReview();
      setStep('destination');
      return;
    }
    if (step === 'method') {
      handlers.onClose();
      return;
    }
    setStep('method');
  }, [step]);

  return {
    step, currentStep: stepNumber[step], getTitle, reset, showMethod, showDestination, showReview, showOtp, goBack
  };
};
